module.exports = __webpack_public_path__ + "img/fevend-large-page.a3956efd.png";